<template>
  <div class="frmlogin">

    <form @submit.prevent="handleDateSubmit($event)" class="form-signin shadow p-3 mb-5 bg-white rounded">

    <div class="outercaption"> SEARCH NEWS</div>
    <div>
      <div class="innercaption">{{$t("KEYWORD")}}:</div>
      <input type="text" v-model="keyword" class="frmcontrol" />
    </div>
    
    <div>
      <div class="innercaption">FROM:</div>
  
      <VueDatePicker :locale="lang" v-model="startdate" auto-apply></VueDatePicker>
    </div>
    <div>
      <div class="innercaption">TO:</div>
      <VueDatePicker :locale="lang" v-model="enddate" auto-apply></VueDatePicker>
    </div>
    
    <button class="btn btn-primary w-30 submitbtn" type="submit" >Get News <font-awesome-icon icon="fa-solid fa-right-to-bracket" class="fonttxt"/></button>
    
       
  </form>
  <div class="card shadow classfilter">
    <div class="outercaption">FILTER BY YEAR</div>
    <div class="spantextdiv">
      <div class="shadow yearscssformat" style="margin-top: 10px;" v-for="ayear in getyears" @click="$emit('getYear', $event.target.value=`${ayear.yearid}`)">
        {{ ayear.yeardesc }}
      </div>
    </div>
  </div>
  <!-- <VideoPlaryer /> -->
 
</div>
</template>
<script setup>
let langcode = localStorage.getItem("lang")
  if(langcode === null) {
        localStorage.setItem("lang", "en")
  }
</script>
<script>
import { ref } from 'vue'
import { useToast } from "vue-toastification";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment';
import en from '@/assets/i18n/en.json';
import fr from '@/assets/i18n/fr.json';

import 'moment/min/locales.min'
const startdate = ref(new Date())
const enddate = ref(new Date())

export default {
  props: ['getyears'],
  data() {
      return {
        keyword: '',
        startdate: moment(startdate).format('YYYY-MMMM-DD'),
        enddate: moment(enddate).format('YYYY-MMMM-DD'),
        error: '',
        lang: '',
        // getyears: [],
      }
    },
    methods: {
     
      async handleDateSubmit($event) {
        try {
        //  const response = await axios.post('login/', {
        if(this.keyword === '') {
          let error = "Please enter a keyword. It is required to continue."
          const toast = useToast();
          toast.success(error, {
          timeout: 6000
          });
        }
        else {
          this.$emit('handleDateSubmit', $event.target.value=this.keyword, $event.target.value=this.startdate, event.target.value=this.enddate)
        }

        } catch (e) {
          e = "Please select a valid date"
          const toast = useToast();
          toast.success(e, {
          timeout: 6000
          });
        }
      },

      async getYear($event) {
        this.$emit('getYear', $event)
      }
     
 
      },
    


    async mounted(){
    
      this.lang = localStorage.getItem("lang")
       //------------YEARS---------------
      // await axios.get('getallyears/').then(
      //     response => {
      //         this.getyears = response.data
      //   })
      //   .catch((error) => {
      //       console.log(error)
      //     })
    },
    watch:{
    //   type(val){
    //       this.fieldType = val;
    // }
  },
 
}

</script>

<style scoped>
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #003;
}
  .form-signin {
    width: auto;
    max-width: 330px;
    padding: 15px;
    margin: auto;
    margin-top: 50px;
  }
  
  .submitbtn{
    margin-top: 50px;
  }
  .yearscssformat {
    margin-left: 10px;
    width: 50px;
    float: left;
    padding:4px;
    font-weight: bold;
    font-size: 18px;
    color: rgb(65, 117, 175);
    cursor: pointer;
  }
.classfilter {
  padding: 30px;
}
.outercaption {
  font-size: 20px;
  font-weight: bold;
  color: rgb(13, 58, 110);
  
}
.innercaption {
  font-weight: bold;
  font-size: 18px;
  color: rgb(65, 117, 175);
  margin-top: 15px;
}
   /*===================MEDIA SCREENS TAMPLATES===============*/
   /* Extra small devices (phones, 600px and down) */
   @media only screen and (max-width: 600px) {
    .classfilter {
      margin-left: 20px;
      margin-right: 20px;
    }
   }
  
   /* Small devices (portrait tablets and large phones, 600px and up) */
   @media only screen and (min-width: 600px) {
  
   }
   
   /* Medium devices (landscape tablets, 768px and up) */
   @media only screen and (min-width: 768px) {
  
   }
   
   /* Large devices (laptops/desktops, 992px and up) */
   @media only screen and (min-width: 992px) {

   }
   
   /* Extra large devices (large laptops and desktops, 1200px and up) */
   @media only screen and (min-width: 1200px) {
      
   } 
</style>